import { ResponseDataGet } from "../../../../models/responseDataGet";
import { ResponseDataTest } from "../../../../models/responseDataTest";
import { agroApi } from "../../api";
import { EntTypesOfFertilizersFilter } from "../../../../models/filters/typesOfFertilizersFilter";
import { EntTypesOfFertilizers } from "../../../../models/handBooks/typesOfFertilizers";
import { Paths } from "../../../../paths";

export const typesOfFertilizersApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getTypesOfFertilizers: builder.query<ResponseDataGet<EntTypesOfFertilizers>, EntTypesOfFertilizersFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.types_of_fertilizers }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getTypesOfFertilizersById: builder.query<ResponseDataTest<EntTypesOfFertilizers>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.types_of_fertilizers }/${ id }`,
		method: 'GET'
	  })
	}),
	addTypesOfFertilizers: builder.mutation<ResponseDataTest<EntTypesOfFertilizers>, EntTypesOfFertilizers>({
	  query: (body) => ({
		url: `${ Paths.handbooks.types_of_fertilizers }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editTypesOfFertilizers: builder.mutation<ResponseDataTest<EntTypesOfFertilizers>, EntTypesOfFertilizers>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.types_of_fertilizers }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteTypesOfFertilizers: builder.mutation<ResponseDataTest<EntTypesOfFertilizers>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.types_of_fertilizers }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetTypesOfFertilizersQuery,
  useAddTypesOfFertilizersMutation,
  useEditTypesOfFertilizersMutation,
  useDeleteTypesOfFertilizersMutation
} = typesOfFertilizersApi;
